
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { ProspectFormData } from '../types';

export const useFormState = () => {
  const [isLoading, setIsLoading] = useState(false);
  
  const methods = useForm<ProspectFormData>({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      industry: '',
    }
  });

  const showSuccessToast = () => {
    toast.success('Contact added successfully!');
  };

  const showErrorToast = (error: unknown) => {
    toast.error(error instanceof Error ? error.message : 'Failed to add contact');
  };

  return {
    methods,
    isLoading,
    setIsLoading,
    showSuccessToast,
    showErrorToast
  };
};
